import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-search-box',
  templateUrl: './search-box.component.html',
  styleUrls: ['./search-box.component.css'],
})
export class SearchBoxComponent implements OnInit {

  @Input()
  key: string;

  @Output()
  onEdit = new EventEmitter<string>();

  @Input()
  placeHolderText:string;

  constructor() {
  }

  ngOnInit() {
  }

  notifyEdit(){
    this.onEdit.emit(this.key);
  }

}
